<template>
  <div @click.capture="onCaptureClick">
    <JoszakiButton
      type="success"
      icon-left="chevron-right"
      icon-left-pack="fas"
      size="lg"
      :disabled="disabled"
      @click="$emit('click', $event)"
    >
      {{ $t("requestTender.next") }}
    </JoszakiButton>
  </div>
</template>

<script>
export default {
  name: "WizardNextButton",
  props: {
    disabled: { type: Boolean, default: false },
  },
  emits: ["click"],
  methods: {
    // JoszakiButton swallows clicks while disabled (stopPropagation, no emit),
    // but the wizard tracks every attempt to advance, so a click on the
    // disabled button is forwarded from the capture phase instead.
    onCaptureClick(event) {
      if (this.disabled) {
        this.$emit("click", event);
      }
    },
  },
};
</script>
